import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';

const toolName = 'get-all-selectors-from-site' as const;

const argsSchema = z.object({});

export const getAllSelectorsFromSiteTool = defineToolRegistryManifest({
  id: toolName,
  type: 'designer',
  permission: [{resource: 'SiteStyleBlock', action: 'read'}],
  prettyName: 'Get all selectors',
  prettyStatus: {
    executed: 'Searched available selectors',
    executing: 'Searching available selectors',
    failed: 'Failed to search selectors',
  },
  confirmBeforeExecuting: false,
  timeout: 30000,
  compaction: {
    prompt:
      'Summarize the site selectors list. Preserve all CSS selector names and group by type (class, tag, combo). Remove verbose formatting.',
    staleAfterTurns: 5,
    supersededOnRecall: true,
  },
  llmTool: {
    name: toolName,
    description: dedent`
      Returns an array of all CSS selectors available on the site.
      Use this tool when you need to get a higher-level view of the site's styles.
      Once you have the selectors, you can use the search-styles tool to get richer information for each selector.
    `,
    inputSchema: argsSchema,
  },
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});
